import { createContext } from 'react';

const eqpgContext = createContext();

export default eqpgContext;
